<div class="list-container">
  <div class="content">
    <div class="top-section">
      <div class="search-bar">
        <button class="back-btn" (click)="goBack()">
          <img src="assets/back.png" alt="">
        </button>
        <div class="search-input">
          <input type="text" placeholder="Search a Utility" [value]="searchTerm" (input)="onSearchInput($event)"
            (keyup.enter)="loadUtility(1)">
          <button class="search-btn" (click)="loadUtility(1)">→</button>
        </div>
        <div class="filter">
          <span>Filter By</span>
          <div class="dropdown">
            <button class="d-btn" (click)="showFilterDropdown = !showFilterDropdown">
              {{selectedFilter}}
              <img src="assets/down.jpg" alt="Dropdown" class="dropdown-icon" [class.rotated]="showFilterDropdown">
            </button>
            <div class="dropdown-content" *ngIf="showFilterDropdown">
              <button *ngFor="let option of filterOptions" (click)="onFilterChange(option)">
                {{option}}
              </button>

            </div>
          </div>
        </div>
      </div>
      <button class="add-utility" (click)="addUtility()">Add a Utility</button>
    </div>

    <div class="utilities-section">
      <div class="utilities-heading">
        <div class="heading-left">
          <div class="circle"></div>
          <h2>{{ headingLabel }}</h2>
        </div>
        <app-pagination *ngIf="!error && utilities.length > 0" [totalItems]="totalItems" [itemsPerPage]="itemsPerPage"
          [currentPage]="currentPage" (pageChanged)="onPageChanged($event)">
        </app-pagination>
      </div>
      <div class="utilities-table">
        <div class="table-header">
          <div>Logo</div>
          <div>Name</div>
          <div>State</div>
          <div>Phone Number</div>
          <div>Status</div>
          <div>Actions</div>
        </div>
        <div class="table-body">
          <div class="utility-row" *ngFor="let utility of filteredUtilities">
            <div class="logo-cell">
              <div class="utility-logo">
                <img [src]="logos[utility.id] || 'assets/utility_logo.png'" (error)="onImageError($event)"
                  alt="Utility Logo">
              </div>
            </div>
            <div>{{utility.name}}</div>
            <div>{{utility.state}}</div>
            <div>{{utility.phone_number}}</div>
            <div>
              <span class="status-badge" [class.active]="utility.active === true">
                {{utility.active?"Active": "Inactive"}}
              </span>
            </div>
            <div>
              <button class="view-config" (click)="onViewConfig(utility)">
                View Configuration
                <div class="forward-btn">
                  →
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>